import { formatNumberCoords } from '../utils/functions';
const oldhamCoords = [
  53.62319704626493,
  -2.027233205727219,
  53.60344106032369,
  -2.0361595973287816,
  53.59732908986301,
  -2.0550423487936254,
  53.594272772994856,
  -2.054355703285813,
  53.59305018433958,
  -2.0677452906881566,
  53.59855155470344,
  -2.106884084633469,
  53.58815947594652,
  -2.120616994789719,
  53.583675829321216,
  -2.1360665187155004,
  53.58245293405217,
  -2.1552925929342504,
  53.566348179751934,
  -2.1497994288717504,
  53.5583954696797,
  -2.170055471352219,
  53.54493363090169,
  -2.167308889320969,
  53.52942681421828,
  -2.186191640785813,
  53.52677376356998,
  -2.170055471352219,
  53.5196301088429,
  -2.1666222438131566,
  53.521263050419684,
  -2.160099111488938,
  53.51228109282914,
  -2.1607857569967504,
  53.512689404936005,
  -2.1734886988912816,
  53.50513499410191,
  -2.179668508461594,
  53.493290234786215,
  -2.1635323390280004,
  53.491656215182914,
  -2.1360665187155004,
  53.50043833030153,
  -2.121990285805344,
  53.505951752081714,
  -2.118900381020188,
  53.50983113757006,
  -2.1031075343405004,
  53.519834229982074,
  -2.091777883461594,
  53.52248771529755,
  -2.0636254176412816,
  53.527181936025336,
  -2.0646553859030004,
  53.52759010454714,
  -2.0220833644186254,
  53.523100034460086,
  -2.018650136879563,
  53.522895929056006,
  -1.9977074488912816,
  53.50615593911761,
  -1.9554787501608129,
  53.51309771310872,
  -1.9170266017233129,
  53.52065070470428,
  -1.9276696070944066,
  53.53983333119463,
  -1.9129067286764379,
  53.551257149128226,
  -1.9166832789694066,
  53.561658300840364,
  -1.939342580727219,
  53.57654177480612,
  -1.9554787501608129,
  53.587751891362956,
  -1.9771080836569066,
  53.61627331990326,
  -2.0069771632467504,
  53.61545868919694,
  -2.020195089272141,
];

export const oldhamAreaCoords = formatNumberCoords(oldhamCoords);
